define(function (require) {
    var $ = require("jquery");
    var cookie = require("cookie");
    var querystring = require("querystring");

    var stateParameterName = window.scan && window.scan.stateParameterName ? window.scan.stateParameterName : "scan_state";

    $(".state-selector select").on("change", function (ev) {
        var $selectedState = $(ev.target).val();

        var queryStringParams = querystring.parse();
        queryStringParams[stateParameterName] = $selectedState;

        window.location = "?" + querystring.stringify(queryStringParams);
    });

    $(".state-selector a").on("click", function (ev) {
        var selectedState = $(this).attr('href');

        if (selectedState.startsWith("?" + stateParameterName)) {
            selectedState = selectedState.slice(stateParameterName.length + 2);
        }

        var queryStringParams = querystring.parse();
        queryStringParams[stateParameterName] = selectedState;

        window.location = "?" + querystring.stringify(queryStringParams);
        return false;
    });

    if ($("#stateSelectionModal").length && $("#stateSelectionModal").hasClass("show")) {
        var isCookiesEnabled = cookiesEnabled() && navigator.cookieEnabled;
        if (!isCookiesEnabled) {
            $("#cookiesWarningMessage, #cookiesWarningMessage div").show();
        }

        // add classes to prevent tons of scrollbars....
        $("body, html").addClass("no-scroll");
    }

    // returns true when a cookie can be written and retrieved and false otherwise
    function cookiesEnabled() {
        cookie.set("scantc", "1");
        if (cookie.get("scantc") == "1") {
            cookie.remove("scantc");
            return true;
        }
        return false;
    }
});
